export const MAX_DID_YOU_MEAN_OPTIONS = 3;
export const AUTO_CORRECT_STRING_KEY = '{autocorrectString}';
export const SEARCH_STRING_KEY = '{searchString}';
export const AUTO_CORRECT_OPTIONS_KEY = '{autocorrectOptions}';
